// extracted by mini-css-extract-plugin
export default {"ButtonSection":"gridCategoria_ButtonSection__d9rHl","UlCuston":"gridCategoria_UlCuston__3apQ-"};